// Constants for MilkJournals functionality
import { API_BASE_URL } from "../../../../utils/apiBase";
export { API_BASE_URL };

export const ROWS_PER_PAGE = 30;

export const PAPER_TYPES = {
  SINGLE_DAY: "single_day",
  WEEKLY: "weekly",
  HALF_MONTHLY: "half_monthly",
};

// Paper upload costs (in KES)
export const PAPER_COSTS = {
  [PAPER_TYPES.SINGLE_DAY]: 20,
  [PAPER_TYPES.WEEKLY]: 80,
  [PAPER_TYPES.HALF_MONTHLY]: 150,
};

// Annotation payment rates (in KES) - paid to annotators on accepted work
export const ANNOTATION_RATES = {
  [PAPER_TYPES.SINGLE_DAY]: 15,
  [PAPER_TYPES.WEEKLY]: 60,
  [PAPER_TYPES.HALF_MONTHLY]: 130,
};

// Default paybill for collecting upload fees - this is a designated internal account
// for collecting annotation service fees (not exposed to users, used for internal accounting)
export const DEFAULT_FEE_PAYBILL = "DEFAULT_ACC_001";

// Paper ID configuration
export const PAPER_ID_LENGTH = 13;

export const DAYS_OF_WEEK = ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

// Fallback image for broken image URLs
export const IMAGE_FALLBACK_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect fill='%23f0f0f0' width='200' height='200'/%3E%3Ctext fill='%23999' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3EImage not available%3C/text%3E%3C/svg%3E";

// PDF Layout constants
export const PDF_LAYOUT = {
  PAGE_MARGIN_LEFT: 10,
  PAGE_MARGIN_TOP: 15,
  TEXT_MARGIN_LEFT: 14,
  TABLE_START_Y: 38,
  TABLE_WIDTH: 277,
  TABLE_HEADER_HEIGHT: 8,
  ROW_HEIGHT: 6,
  MIN_DATE_COL_WIDTH: 15,
  TOTAL_DATE_AREA_WIDTH: 280,
  PAGE_INFO_X: 250,
  FOOTER_Y: 200,
};
